/**
 * The tab strip shared by the two Learning Moments views.
 *
 * They are separate routes rather than one host component because the
 * definitions page owns a full-page create/edit form; switching tabs mid-edit
 * should be a navigation, not a hidden state change.
 */

import { useNavigate } from 'react-router-dom';
import { TabStrip } from '@shared-ui/components';

export type LearningMomentTabKey = 'definitions' | 'categories' | 'runs' | 'taxonomy';

const TABS = [
  { key: 'definitions' as const, label: 'Definitions' },
  { key: 'categories' as const, label: 'Error Categories' },
  { key: 'runs' as const, label: 'Normalisation Runs' },
  { key: 'taxonomy' as const, label: 'Taxonomy' },
];

const ROUTES: Record<LearningMomentTabKey, string> = {
  definitions: '/learning-moments',
  categories: '/learning-moments/categories',
  runs: '/learning-moments/runs',
  taxonomy: '/learning-moments/taxonomy',
};

export function LearningMomentTabs({ active }: { active: LearningMomentTabKey }) {
  const navigate = useNavigate();
  return (
    <TabStrip
      tabs={TABS}
      active={active}
      onChange={(key) => navigate(ROUTES[key])}
      ariaLabel="Learning moment views"
    />
  );
}
